import { CustomCellRendererProps } from 'ag-grid-react'
import IdeyaTypography from '../../common/antd/ideya-typography'
import { selectThemeStyle } from '../../features/setting/setting.slice.ts'
import { useAppSelector } from '../../redux/hooks.ts'
import { selectManagementInput } from '../../redux/slices/management-input.slice.ts'
import { useSelector } from 'react-redux'
import { getBookIdeaLink } from './book-idea-link.ts'

export interface BookNameCellRendererParams {
  // Date range carried into the idea-list link. Defaults to the management
  // page's range when the host grid does not pass one.
  dateRange?: [string | null, string | null]
  // Firm-level rows have no single book to open.
  groupByFirm?: boolean
}

export const BookNameCellRenderer = (
  params: CustomCellRendererProps & BookNameCellRendererParams
) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  const managementInput = useSelector(selectManagementInput)

  if (!params || !params.data) return null
  const bookName = params.value
  const dateRange = params.dateRange ?? managementInput.dateRange
  const { href, isInactive } = getBookIdeaLink({
    userId: params.data.userId,
    userName: params.data.userName,
    bookStatus: params.data.bookStatus,
    canSeeBookDetail: params.data.canSeeBookDetail,
    groupByFirm: params.groupByFirm,
    startDate: dateRange[0],
    endDate: dateRange[1],
  })

  if (!href)
    return (
      <IdeyaTypography.Text
        style={{
          color: isInactive ? themeStyle.disabledBookName : '',
        }}
      >
        {bookName}
      </IdeyaTypography.Text>
    )

  return (
    <a
      href={href}
      target={'_blank'}
      rel={'noopener noreferrer'}
      style={{
        color: themeStyle.bookNameLink,
        textDecoration: 'underline',
        cursor: 'pointer',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {bookName}
    </a>
  )
}
